import React from "react";
import { AlertCircle, CheckCircle2, Clock3 } from "lucide-react";
import { getDocumentAmount, getDocumentDate, getDocumentStatus, getPartyName, money } from "./documentHelpers";

const iconMap = {
  paid: CheckCircle2,
  overdue: AlertCircle,
  pending: Clock3,
  draft: Clock3,
};

const DocumentStatusBanner = ({ row, config, onViewActivity }) => {
  const status = getDocumentStatus(row, config);
  const Icon = iconMap[status.tone] || Clock3;
  const party = getPartyName(row, config);

  return (
    <div className={`document-status-banner ${status.tone}`}>
      <Icon size={22} />
      <div>
        <strong>{status.label} {config.singular || "Document"}</strong>
        <span>
          {money(getDocumentAmount(row, config))} for {party} {getDocumentDate(row, config) !== "-" ? `on ${getDocumentDate(row, config)}` : ""}
        </span>
      </div>
      <button type="button" onClick={onViewActivity}>View Activity</button>
    </div>
  );
};

export default DocumentStatusBanner;
